import { useSWRResource } from 'util/resource/useSWRResource';
import useSWR from 'hooks/useSWR';
import { HighlightedSectionList, companiesAPIUrls } from 'apis/CompanyAPI/companies/companiesApi';

export default function useHighlightedUsers(companySlug: string) {
  const swrResult = useSWR<HighlightedSectionList>(companiesAPIUrls.highightedUsers.list(companySlug));
  return useSWRResource(swrResult);
}
